import Icon from "atoms/icons/icon";
import React from "react";
import { Icons } from "atoms/constants/icons";
import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "../../atoms/constants/button-styles";
import ShareSpaceItemRecord from "models/view-models/share-spaces/share-space-item-record";
import ShareSpaceItem from "models/interfaces/share-spaces/share-space-item";

const BASE_CLASS_NAME = "c-share-space-panel-item";
interface ShareSpacePanelItemProps {
    sharedItem: ShareSpaceItemRecord;
    onDelete: (shareSpaceItem: ShareSpaceItem) => void;
}
const ShareSpacePanelItem: React.FC<ShareSpacePanelItemProps> = (
    props: ShareSpacePanelItemProps
) => {
    const { sharedItem, onDelete } = props;
    const title = sharedItem.section?.getFullyQualifiedDisplayTitle();
    const subtitle = sharedItem.publication?.getDisplayCodeEditionAndTitle();

    const handleDelete = async () => {
        onDelete(sharedItem);
    };
    return (
        <div className={BASE_CLASS_NAME}>
            <div>
                <div className={`${BASE_CLASS_NAME}__title`}>{title}</div>
                <div className={`${BASE_CLASS_NAME}__subtitle`}>{subtitle}</div>
            </div>
            <Button
                size={ButtonSizes.XSmall}
                style={ButtonStyles.TertiaryAlt}
                onClick={handleDelete}>
                <Icon type={Icons.Close}></Icon>
            </Button>
        </div>
    );
};

export default ShareSpacePanelItem;
